import NewDocumentTag from './NewDocumentTag.component';

export default NewDocumentTag;